import { GET_DEAL_BUILDER_CUSTOMER_CONTACTS } from './getCustomerContacts';
import { GET_INVENTORY_FULL_LIST } from './getInventoryFullList';
import { GET_EQUIPMENT_DETAILS_BY_ID } from './getEquipmentDetailsById';
import { GET_DEAL_BUILDERS } from './getDealBuilders';
import { GET_ACTIVE_DEAL_BUILDER } from './getActiveDealBuilder';
import { START_DEAL_BUILDER } from './startDealBuilder';
import { UPSERT_DEAL_BUILDER_CONTACTS } from './upsertDealBuilderContacts';
import { UPSERT_DEAL_BUILDER_EQUIPMENTS } from './upsertDealBuilderEquipments';
import { UPDATE_DEAL_BUILDER_QUOTE } from './updateDealBuilderQuote';
import { UPDATE_PROPOSAL } from './updateProposal';
import { CREATE_DEAL_BUILDER_QUOTE_PROPOSAL } from './createDealBuilderQuoteProposal';
import { CREATE_DEAL_BUILDER_PROPOSAL } from './createDealBuilderProposal';

export const dealBuilderApi = {
  getCustomerContacts: GET_DEAL_BUILDER_CUSTOMER_CONTACTS,
  getInventoryFullList: GET_INVENTORY_FULL_LIST,
  getEquipmentDetailsById: GET_EQUIPMENT_DETAILS_BY_ID,
  getDealBuilders: GET_DEAL_BUILDERS,
  getActiveDealBuilder: GET_ACTIVE_DEAL_BUILDER,
  startDealBuilder: START_DEAL_BUILDER,
  upsertDealBuilderContacts: UPSERT_DEAL_BUILDER_CONTACTS,
  upsertDealBuilderEquipments: UPSERT_DEAL_BUILDER_EQUIPMENTS,
  updateDealBuilderQuote: UPDATE_DEAL_BUILDER_QUOTE,
  updateProposal: UPDATE_PROPOSAL,
  createDealBuilderQuoteProposal: CREATE_DEAL_BUILDER_QUOTE_PROPOSAL,
  createDealBuilderProposal: CREATE_DEAL_BUILDER_PROPOSAL,
};

export type {
  CustomerContactItem,
  CustomerContactsQueryResponse,
  DealBuilderEntity,
  DealBuilderProposal,
  DealBuilderQuote,
  GetDealBuildersResponse,
  GetDealBuildersVariables,
  GetActiveDealBuilderResponse,
  GetActiveDealBuilderVariables,
  InventoryEquipmentItem,
  InventoryFullListResponse,
  ProposalContactEntity,
  ProposalEquipmentEntity,
  StartDealBuilderContactInput,
  StartDealBuilderEntity,
  StartDealBuilderResponse,
  StartDealBuilderVariables,
  UpsertDealBuilderContactsResponse,
  UpsertDealBuilderContactsVariables,
  UpsertDealBuilderEquipmentsResponse,
  UpsertDealBuilderEquipmentsVariables,
  UpdateDealBuilderQuoteResponse,
  UpdateDealBuilderQuoteVariables,
  NotificationInput,
  CreateDealBuilderQuoteProposalResponse,
  CreateDealBuilderQuoteProposalVariables,
  CreateDealBuilderProposalResponse,
  CreateDealBuilderProposalVariables,
} from './types';
